module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Roles","newRole":"New Role","modal":{"newRoleTitle":"New Role","roleDetailsTitle":"Role details","cancel":"Cancel"}},"hr":{"title":"Uloge","newRole":"Nova uloga","modal":{"newRoleTitle":"Nova uloga","roleDetailsTitle":"Detalji uloge","cancel":"Odustani"}}}')
  delete Component.options._Ctor
}
